export const normalizeDepositoRouteValue = (value) => {
  const raw = String(value ?? "").trim().toLowerCase();
  if (!raw) return "";
  if (raw === "2" || raw === "binder2" || raw === "binder 2" || raw === "b2") {
    return "binder2";
  }
  if (raw === "1" || raw === "binder1" || raw === "binder 1" || raw === "b1") {
    return "binder1";
  }
  return "";
};

export const readDepositoFromSearch = (search = "") => {
  const params = new URLSearchParams(search || "");
  return normalizeDepositoRouteValue(
    params.get("deposito") || params.get("dep") || params.get("binder")
  );
};

export const resolveDepositoRoute = ({ search = "", fallback = "" } = {}) =>
  readDepositoFromSearch(search) || normalizeDepositoRouteValue(fallback) || "binder1";

export const buildBinderSearch = (deposito) =>
  `?binder=${encodeURIComponent(
    normalizeDepositoRouteValue(deposito) === "binder2" ? "2" : "1"
  )}`;
